import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserRole } from '../../auth/models/user.model';
import { AuthService } from '../../auth/services/auth.service';
import { navigation } from './../../../nav';

export type NavItem = {
    title: string;
    route: string;
    icon: string;
    roles?: UserRole[];
    hidden?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavService implements OnDestroy {
    public navigation: NavItem[] = [];
    private ngUnsubscribe: Subject<void> = new Subject();

    constructor(private authService: AuthService) {
        this.authService.currentUser
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(_ => this.navigation = navigation.filter(nav => this.authService.hasAccess(nav.roles) && !nav.hidden));
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
